import { AssetsLoader } from '@dealstack/frontend/shared/components/AssetsLoader/AssetsLoader';
import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';
import { ButtonsCenter } from '@dealstack/frontend/shared/components/fundament/Button/ButtonLayouts';
import { Modal } from '@dealstack/frontend/shared/components/fundament/Modal/Modal';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';
import { memo } from 'react';
import styled from 'styled-components';

interface IDealArchiveModal {
	onSubmit: () => void;
	onClose: () => void;
	isDealArchived: boolean;
	className?: string;
}
const ArchiveDealConfirmationModal = ({
	onSubmit,
	onClose,
	isDealArchived,
	className,
}: IDealArchiveModal) => {
	const text = isDealArchived
		? {
				bodyText: `You're on your way to unarchive Deal. Don't worry - all Investment Programmes will stay archived. You can choose by your own which one would you like to see.`,
				buttonText: 'Yes, please unarchive this Deal',
			}
		: {
				bodyText: `This action will archive whole Deal with all Investment Programmes inside it. Be warned that they won't be visible for anyone from now on.`,
				buttonText: 'Yes, please archive this Deal',
			};
	return (
		<Modal onClose={onClose} className={className}>
			<AssetWrapper>
				<AssetsLoader src="/context/admin/mip-manage/attention.png" />
			</AssetWrapper>

			<SectionHeader size="h4b" title="Are you sure?" />

			<BodyText colorFaded variant="p-md">
				{text.bodyText}
			</BodyText>
			<ButtonsCenter>
				<ArchiveButton
					onClick={onSubmit}
					icon="checkmark-circle-contained-filled"
					iconPlacement="left"
					variant="delete"
				>
					{text.buttonText}
				</ArchiveButton>
			</ButtonsCenter>
		</Modal>
	);
};
const AssetWrapper = styled.div`
	margin-bottom: 1em;
`;
const BodyText = styled(Text)`
	margin-bottom: 0.2em;
`;

const ArchiveButton = styled(Button)``;

const Memoized = memo(ArchiveDealConfirmationModal);
const Styled = styled(Memoized)`
	width: 38rem;
	text-align: center;

	${SectionHeader} {
		& > * {
			justify-content: center;
		}
	}

	${ButtonsCenter} {
		margin-top: 1.5em;
	}
`;

export { Styled as ArchiveDealConfirmationModal };
